/* App-wide loading screen: spinner · #ARSH · Bliss App · B emblem, centred. */
export const BlissLoader = ({ note = null }) => (
  <div className="fixed inset-0 flex items-center justify-center" style={{ background: '#05050A' }} data-testid="bliss-loader">
    <div className="flex flex-col items-center text-center">
      <div className="w-14 h-14 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin mb-5" />
      <p className="font-['Cormorant_Garamond'] text-[#D4AF37]" style={{ fontSize: '1.6rem', lineHeight: 1.1 }} data-testid="bliss-loader-arsh">#ARSH</p>
      <p className="font-['Cinzel'] uppercase text-[#F5D97A] mt-2" style={{ fontSize: 12, letterSpacing: '0.42em', paddingLeft: '0.42em' }} data-testid="bliss-loader-name">Bliss App</p>
      <div className="mt-5 rounded-full overflow-hidden" style={{ width: 84, height: 84, boxShadow: '0 0 26px rgba(212,175,55,0.35)' }}>
        <img src="/icons/bliss_icon.png" alt="Bliss" draggable={false} data-testid="bliss-loader-icon"
          className="w-full h-full object-cover" style={{ transform: 'scale(1.42)' }} />
      </div>
      {note && <p className="font-['Outfit'] text-white/30 mt-4 text-sm">{note}</p>}
    </div>
  </div>
);

export default BlissLoader;
